/*jshint esversion: 6 */

import _ from 'lodash';
export default {
    itemTotal(item,price){

        var sum = 0;
        // if has variant override price
        if(item.variant){
          sum += Number(price);
        }else{
          // item price (either from item/ an option that replaces price)
          var option = item.options.find(x => x.replacesPrice);
          if(option){
            sum += Number(option.price);s
          }else{
            sum += Number(item.price);
          }
        }

        // options price
        sum += Number(_.sum(item.options.filter(itm => !itm.replacesPrice).map(x => Number(x.price))));

        sum = item.quantity * sum;

        return sum;
    }
}